import React from 'react';

const ClienteSelector = ({
  searchTerm,
  setSearchTerm,
  showClientDropdown,
  setShowClientDropdown,
  filteredClientes,
  handleClientSelect,
  selectedClient,
  productosFiltrados,
  productosActuales,
  elementosPorPagina,
  paginaActual,
  totalPaginas,
  mostrarFiltros,
  setMostrarFiltros,
  skusData,
  tipoVista = 'sku' // 'sku' o 'competencias'
}) => {
  const getProductosCount = (cliente) => {
    if (tipoVista === 'competencias') {
      return skusData.filter(sku => 
        sku.ID_CLIENT === parseInt(cliente.id) && sku.COMPETENCE === true
      ).length;
    } else {
      return skusData.filter(sku => 
        sku.ID_CLIENT === parseInt(cliente.id) && sku.COMPETENCE === false
      ).length;
    }
  };

  const getProductosCountText = () => {
    if (tipoVista === 'competencias') {
      return `${productosFiltrados.length} de ${productosActuales.length} competencias`;
    } else {
      return `${productosFiltrados.length} de ${productosActuales.length} productos`;
    }
  };

  const getPlaceholderText = () => {
    return tipoVista === 'competencias' ? 'Buscar cliente...' : 'Buscar cliente...';
  };

  const getLabelText = () => {
    return 'Seleccionar Cliente';
  };

  return (
    <div className="cliente-buscador mb-4">
      <label htmlFor={`cliente-search-${tipoVista}`} className="form-label">
        {getLabelText()}
      </label>
      <div className="search-container-inline">
        <div className="search-input-container">
          <input
            type="text"
            id={`cliente-search-${tipoVista}`}
            className="form-control"
            placeholder={getPlaceholderText()}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => setShowClientDropdown(true)}
            onBlur={() => {
              setTimeout(() => setShowClientDropdown(false), 300);
            }}
          />
          {showClientDropdown && (
            <div className="clientes-dropdown">
              {filteredClientes.map((cliente) => (
                <div
                  key={cliente.id || cliente.ID}
                  className="cliente-option"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleClientSelect(cliente);
                  }}
                >
                  <span className="cliente-nombre">
                    {cliente.nombre_cliente}
                  </span>
                  <span className="cliente-productos-count">
                    {getProductosCount(cliente)} {tipoVista === 'competencias' ? 'competencias' : 'productos'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
        
        {/* Información del cliente y controles */}
        {selectedClient && (
          <div className="cliente-controls-inline">
            <span className="cliente-productos-info">
              {getProductosCountText()}
              {productosFiltrados.length > elementosPorPagina && (
                <span className="text-muted ms-2">
                  (Página {paginaActual} de {totalPaginas})
                </span>
              )}
            </span>
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm toggle-filtros"
              onClick={() => setMostrarFiltros(!mostrarFiltros)}
              title={mostrarFiltros ? "Ocultar filtros" : "Mostrar filtros"}
            >
              <i className={`fas ${mostrarFiltros ? 'fa-eye-slash' : 'fa-eye'} me-1`}></i>
              {mostrarFiltros ? 'Ocultar' : 'Mostrar'} filtros
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClienteSelector;
